<div class="wrap">
  <h2>{{title}}</h2>
  <form [formGroup]="searchPracticePlaceForm" id="searchPracticePlaceForm" class="input_google_search"
    *ngIf="searchPracticePlaceForm">

    <mat-form-field appearance="outline">
      <mat-label>Label</mat-label>
      <input matInput type="text" formControlName="label" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Trouver une discipline</mat-label>
      <input ngx-google-places-autocomplete matInput (onAddressChange)="getAddressPracticePlace($event)"
        placeholder="Indiquez une adresse..." formControlName="practicePlace" />
    </mat-form-field>

  </form>

  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close()">Fermer</button>
    <button type="button" class="confirm" (click)="isLoadingCreation = true; onSubmit()" form="searchPracticePlaceForm"
      [disabled]="searchPracticePlaceForm.invalid || isLoadingCreation"
      [style.opacity]="searchPracticePlaceForm.invalid || isLoadingCreation ? .5 : 1" appChangeColorTheme
      attribute="bgc">{{btnConfirm}}</button>
  </div>
</div>
